import { render, staticRenderFns } from "./PenarikanCard.vue?vue&type=template&id=d5ec10b4&"
import script from "./PenarikanCard.vue?vue&type=script&lang=js&"
export * from "./PenarikanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports